import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import MuiButton from "../../components/basicComponent/MuiButton";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import React, { useState } from "react";
import { useFormik } from "formik";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import { AddHotelCommission } from "./AddHotelCommission";



const HotelCommission = () => {
  const [isactive, setIsActive] = useState<Boolean>(true);
  // const [viewActive, setViewActive] = useState(false);
  const [defaultActive, setDefaultActive] = useState(false)
  const [activeForm, setActiveForm] = useState<"create" | "view">("create");
  const [deafult, setDefault] = useState(false);
  const [viewActive, setViewActive] = useState(false);


   const initialValues = {
        commissionType: "",
        supplierName: "",
        hotelType: "",
        assignType: "",
        basicFare: "",
        flat: "",
        bookFrom: "",
        bookTo: "",
        checkIn: "",
        checkOut: ""
      };

 
const formik = useFormik({
        initialValues,
        onSubmit(values, formikHelpers) {
          console.log("Form submitted with values:", values);
        },
      });
    


  const SetDefault = () => {
    return (
      <>
        <div className="card card-custom">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6 col-lg-3">
                <MuiSearchSelect
                  label="Category List"
                  placeholder={"Category List"}
                  options={[]}
                  onChange={(value, id, data) => {
                    formik.setFieldValue("hotel_type", value);
                    formik.setFieldValue("hotel_typeCode", data.code);
                  }}
                  onBlur={() =>
                    formik.setFieldTouched("hotel_type", true)
                  }
                  value={formik.values.hotelType}
                />
              </div>
              <div className="col-md-6 col-lg-3">
                <MuiSearchSelect
                  label="Business Unit"
                  placeholder={"Business Unit"}
                  options={[]}
                  onChange={(value, id, data) => {
                    formik.setFieldValue("hotel_type", value);
                    formik.setFieldValue("hotel_typeCode", data.code);
                  }}
                  onBlur={() =>
                    formik.setFieldTouched("hotel_type", true)
                  }
                  value={formik.values.hotelType}
                />
              </div>
              <div className="col-md-6 col-lg-3">
                <MuiInput
                  placeholder="Branch Name"
                  label={"Branch Name"}
                  onChange={(value) =>
                    formik.setFieldValue("flat", value)
                  }
                  onBlur={() =>
                    formik.setFieldTouched(
                      "flat",
                      true
                    )
                  }
                  value={formik.values.flat}
                />
              </div>
              <div className="col-md-6 col-lg-3">
                <MuiInput
                  placeholder="Customer Name"
                  label={"Customer Name"}
                  onChange={(value) =>
                    formik.setFieldValue("flat", value)
                  }
                  onBlur={() =>
                    formik.setFieldTouched(
                      "flat",
                      true
                    )
                  }
                  value={formik.values.flat}
                />
              </div>
              <div className="col-md-12 d-flex justify-content-end">
                <div>
                  <MuiButton
                    className="main-btn get-btn mr-5 my-3"
                    variant="contained"
                    size="large"
                    type="submit"
                    label={"Submit"}
                  />
                </div>
                <div className="mx-4">
                  <MuiButton
                    className="user-button ml-5 my-3"
                    variant="contained"
                    size="large"
                    type="submit"
                    label={"Cancel"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };


  const SetViewActive = () => {
    return (
      <>
        <div className="card card-custom">
          <div className="card-body">
            <div className="row mt-4">
              <div className="col-md-4">
                <MuiSearchSelect
                  label="Type "
                  onChange={function (date: string): void {
                    throw new Error("Function not implemented.");
                  }}
                  placeholder={"Type"}
                  options={[]}
                  value={""}
                />
              </div>
              <div className="col-md-4">
                <MuiSearchSelect
                  label="Based On "
                  onChange={function (date: string): void {
                    throw new Error("Function not implemented.");
                  }}
                  placeholder={"Based On"}
                  options={[]}
                  value={""}
                />
              </div>
              <div className="col-md-2 mt-2">
                <div className=" w-full">
                  <MuiButton
                    className="main-btn get-btn"
                    variant="contained"
                    size="large"
                    type="submit"
                    label={"Get"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };






  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 managebookingg">
              <h3 className="card-title titlecolorr">
                Hotel Commission/Markup
              </h3>
              <div>
                <button
                  className="fliter-btn me-2"
                  onClick={() => {
                    setIsActive(true);
                    setViewActive(false);
                    setDefault(false)
                  }}
                >
                  <span>Create Assign Commission/Mark Up</span>
                </button>
                <button className="fliter-btn me-2"
                  onClick={() => {
                    setViewActive(true);
                    setIsActive(false);
                    setDefault(false)
                  }}
                >
                  <span>View Assign Commission/Mark Up</span>
                </button>
                <button
                  onClick={() => {
                    setViewActive(false);
                    setIsActive(false);
                    setDefault(true)
                  }}
                  className="fliter-btn">
                  <span>Set Default</span>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">




                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-custom">
                      <div className="card-body">
                        {isactive && <AddHotelCommission/>}
                        {deafult && <SetDefault />}
                        {viewActive && <SetViewActive />}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default HotelCommission;
